import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Never retry 4xx errors (client errors are permanent)
        if (isApiError(error) && error.status && error.status < 500) {
          return false;
        }
        // Retry 5xx and network errors once
        return failureCount < 1;
      },
      refetchOnWindowFocus: true,
    },
  },
});
